import * as types from 'Redux/Types/GlobalTypes'

const INITIAL_STATE = {
  loading: false,
  pageLoader: true,
  leftNavigation: {
    open: true,
  },
  userSessionToken: null,
  userSessionTokenExpirationDate: null,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.GET_USER_SESSION_TOKEN:
      return {
        ...state,
        userSessionToken: null,
      }
    case types.GET_USER_SESSION_TOKEN_FAILED:
      return {
        ...state,
        userSessionToken: null,
      }
    case types.GET_USER_SESSION_TOKEN_SUCCEEDED:
      return {
        ...state,
        userSessionToken: payload.authToken,
        userSessionTokenExpirationDate: payload.authTokenExpirationDate,
      }

    default:
      return state
  }
}
